module.exports = __webpack_public_path__ + "static/cappuccino@2x-b79d344ff8354f13a4f2c40bd916b17f.png";